import { Outlet } from "react-router-dom";
import HorizontalLayout from "./HorizontalLayout";

/**
 * Keeps Header + Sidebar + MobileNav mounted across main app tabs so
 * DeptTeamSelector and other sidebar state are not reset on navigation.
 */
const MainAppLayout = () => {
  return (
    <HorizontalLayout>
      <Outlet />
    </HorizontalLayout>
  );
};

export default MainAppLayout;
